import React from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo512_white.png';

// Ícones para as redes sociais
const LinkedInIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-4.481 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.59-11.018-3.714v-2.155z"/></svg>;
const TwitterIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>;

const Footer = () => {
    const { t } = useTranslation();
    
    return (
        <footer className="bg-primary text-gray-400 py-12">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 text-center md:text-left">
                    
                    {/* Coluna 1: Marca e Tagline */}
                    {/* AQUI: Adicionado data-aos-offset="50" */}
                    <div className="space-y-4" data-aos="fade-up" data-aos-offset="50">
                        <div className="flex justify-center md:justify-start">
                            <img src={logo} alt="AironCore Logo" width={180} height={'auto'} />
                        </div>
                        <p className="max-w-xs mx-auto md:mx-0">{t('footer_tagline')}</p>
                    </div>

                    {/* Coluna 2: Links de Navegação */}
                    {/* AQUI: Adicionado data-aos-offset="50" */}
                    <div data-aos="fade-up" data-aos-delay="200" data-aos-offset="50">
                        <h4 className="font-bold text-white text-lg mb-4">{t('footer_links_title')}</h4>
                        <ul className="space-y-2">
                            <li><a href="#solutions" className="hover:text-accent transition-colors">Soluções</a></li>
                            <li><a href="#threats" className="hover:text-accent transition-colors">Ameaças</a></li>
                            <li><a href="#why-crucial" className="hover:text-accent transition-colors">Benefícios</a></li>
                            <li><a href="#contact" className="hover:text-accent transition-colors">Contato</a></li>
                        </ul>
                    </div>

                    {/* Coluna 3: Redes Sociais */}
                    {/* AQUI: Adicionado data-aos-offset="50" */}
                    <div data-aos="fade-up" data-aos-delay="400" data-aos-offset="50">
                        <h4 className="font-bold text-white text-lg mb-4">{t('footer_social_title')}</h4>
                        <div className="flex justify-center md:justify-start space-x-6">
                            <a href="#" className="hover:text-accent transition-colors"><LinkedInIcon /></a>
                            <a href="#" className="hover:text-accent transition-colors"><TwitterIcon /></a>
                        </div>
                    </div>

                </div>

                <hr className="border-gray-700 my-8" />

                <div className="text-center text-sm">
                    <p>&copy; 2025 AironCore. {t('footer_rights')}</p>
                    <p className="mt-2 text-gray-500">
                        {t('contact_powered_by')} 
                        <a href="https://www.jbkr.com.br" target="_blank" rel="noopener noreferrer" className="font-semibold text-gray-400 hover:text-accent transition-colors"> JBKR Web</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;